import {RaEvent, RaEventType} from "./RaEvent";

export enum TAI_STATUS {
    begin_tai,
    end_tai
}

export class TaiEvent extends RaEvent {

    static TYPE:RaEventType = "tai_event";

    public id:string;

    constructor(private _status:TAI_STATUS, id:string) {
        super(TaiEvent.TYPE)
    }

    public get status():TAI_STATUS {
        return this._status;
    }
}
